import React from "react";

const testDraftKey = (testId) => `test-editor-draft:v1:${testId || "new"}`;
const incompatibleDraftKey = (testId) => `${testDraftKey(testId)}:incompatible`;

export default class TestEditorErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, recoveryAttempted: false };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error("Ошибка отображения конструктора тестов", error, info);
        if (this.state.recoveryAttempted) return;
        try {
            const key = testDraftKey(this.props.testId);
            const localDraft = localStorage.getItem(key);
            if (localDraft != null) {
                // Keep the original payload for diagnostics while preventing a reload loop.
                localStorage.setItem(incompatibleDraftKey(this.props.testId), localDraft);
                localStorage.removeItem(key);
                this.setState({ error: null, recoveryAttempted: true });
            }
        } catch (_) {
            // The fallback below remains available when browser storage is unavailable.
        }
    }

    resetEditor = () => {
        try {
            localStorage.removeItem(testDraftKey(this.props.testId));
        } catch (_) {
            // Reloading is still useful when browser storage is unavailable.
        }
        window.location.reload();
    };

    render() {
        if (!this.state.error) return this.props.children;

        return (
            <div className="rounded-3xl border border-rose-200 bg-white p-8 text-center shadow-sm" role="alert">
                <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-rose-50 text-2xl" aria-hidden="true">!</div>
                <h2 className="mt-4 text-xl font-bold text-slate-950">Не удалось открыть конструктор теста</h2>
                <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-600">
                    Произошла ошибка при отображении редактора. Повторный запуск сбросит только локальную копию
                    черновика — серверные тесты и опубликованные версии не будут удалены.
                </p>
                <button type="button" onClick={this.resetEditor} className="mt-6 rounded-xl bg-slate-950 px-5 py-2.5 text-sm font-semibold text-white hover:bg-slate-800">
                    Повторно открыть редактор
                </button>
            </div>
        );
    }
}
